import { createContext, useEffect, useMemo, useState } from "react";
import { useLazyGetContractByIdQuery } from "../../app/services/contractAPI";
import PropTypes from "prop-types";

const ContractContext =  createContext();

const ContractProvider = ({ children }) => {
const [contractData, setContractData] = useState(null);
const [isContractUpdated, setIsContractUpdated] = useState(false);
const url = window.location.search;
const contractId = new URLSearchParams(url).get("contract");

const [getContract, {
    isSuccess: isContractFetched,
    data: contractDatas,
  },] = useLazyGetContractByIdQuery();

  useEffect(() => { 
    if (contractId) {
        getContract(contractId);
    }
  }, [contractId,isContractUpdated,getContract]);

  useEffect(() => {
    if (isContractFetched && contractDatas) {
      setContractData(contractDatas);
    }
  }, [isContractFetched, contractDatas]);
  

const value = useMemo(() => ({
    contractId,
    contractData,
    setContractData,
    isContractUpdated,
    setIsContractUpdated
}), [contractData, isContractUpdated,contractId,setIsContractUpdated]);

    return (
        <ContractContext.Provider value={value}>
            {children}
        </ContractContext.Provider>
    );
}
ContractProvider.propTypes = { 
    children: PropTypes.node.isRequired,
};
export { ContractProvider, ContractContext }